module.exports = __webpack_public_path__ + "files/6c8b132d30764f9412213c2c844041f4.png";